import {object, string} from "../general-purpose-parsers";

export const parseInputNumberUserInput = object({
    currentValue: string,
});
